import { useSelector } from 'react-redux';

import { PreviewPageType, FormPageTypeEnum } from '@dev/ee-api/ee-api-models';

import { getPaidNewsletterCreatorStore } from '@/store/paidNewsletterCreator/actions'; 
import { DisplayedScreenEnum } from '../components/FormPageDropdownSection';

export const usePageTypeValue = (pageTemplateType: PreviewPageType, clientId):DisplayedScreenEnum => {
    const { template } = useSelector(getPaidNewsletterCreatorStore);
    const templateForm = template.forms?.find((templateForm) => templateForm.blockClientId === clientId);
    const formPayload = templateForm?.formPayload;

    const value = formPayload?.FormPageType ?? [FormPageTypeEnum.DefaultDoubleOptInPage, FormPageTypeEnum.DefaultFormSubmitPage, FormPageTypeEnum.DefaultFormSubscribedPage];

    switch (pageTemplateType) {
        case PreviewPageType.ActivationViaEmail:
            if (value?.[0] === FormPageTypeEnum.ExternalWebsiteDoubleOptInPage) {
                return DisplayedScreenEnum.Externalwebsite;
            } else if (value?.[0] === FormPageTypeEnum.LandingPageDoubleOptInPage) {
                return DisplayedScreenEnum.Landingpage;
            }
            return DisplayedScreenEnum.Defaultpage;
        case PreviewPageType.FormSubmit:
            if (value?.[1] === FormPageTypeEnum.ExternalWebsiteFormSubmitPage) {
                return DisplayedScreenEnum.Externalwebsite;
            } else if (value?.[1] === FormPageTypeEnum.LandingPageFormSubmitPage) {
                return DisplayedScreenEnum.Landingpage
            } else if (value?.[1] === FormPageTypeEnum.ContactUploadSubmitMessage) {
                return DisplayedScreenEnum.Message;
            }
            return DisplayedScreenEnum.Defaultpage;
        case PreviewPageType.AlreadySubscribed:
            if (value?.[2] === FormPageTypeEnum.ExternalWebsiteFormSubscribedPage) {
                return DisplayedScreenEnum.Externalwebsite;
            } else if (value?.[2] === FormPageTypeEnum.LandingPageFormSubscribedPage) {
                return DisplayedScreenEnum.Landingpage;
            }
            else if (value?.[2] === FormPageTypeEnum.ContactUploadSubscribedMessage) {
                return DisplayedScreenEnum.Message;
            }
            return DisplayedScreenEnum.Defaultpage;
        default:
            return DisplayedScreenEnum.Defaultpage;
    }
}